export const MilesRoutes = {
    path: 'miles',
    onboarding: {
        path: 'onboarding',
    },
    explain: {
        path: 'explain',
    },
};
